<template>
  <div class="edit-story layout-column layout-hv-center" id="edit-story">
    <layout-gray>
      <el-collapse v-model="activeNames">
        <el-collapse-item
          :title="
            !is18
              ? '* 1. 成立小組（由輔導員填寫）'
              : '* 1. 成立小組（由代表人及綁定帳號者填寫）'
          "
          name="1"
          id="el1"
        >
          <team
            :editStoryData="editStoryData"
            v-if="!isEdit[0]"
            @edit="changeEditType(0)"
            @next="handleNext('1')"
            :is18="is18"
          />
          <TeamFormUnder18
            :editStoryData="editStoryData"
            v-if="isEdit[0] && !is18"
            @browsMode="changeEditType(0)"
          ></TeamFormUnder18>
          <TeamFormUpper18
            :editStoryData="editStoryData"
            v-if="isEdit[0] && is18"
            @browsMode="changeEditType(0)"
          ></TeamFormUpper18>
        </el-collapse-item>
        <el-collapse-item title="* 2.1 感受" name="2" id="el2">
          <Problem
            :editStoryData="editStoryData"
            v-if="!isEdit[1]"
            @edit="changeEditType(1)"
            @next="handleNext('2')"
          />
          <ProblemForm
            :editStoryData="editStoryData"
            v-else
            @browsMode="changeEditType(1)"
          />
        </el-collapse-item>
        <el-collapse-item
          title="* 2.2 以照片分享歷程：請上傳 DFC 四階段的代表照片，每一階段 1 張，並簡要分享該階段的進行歷程。"
          name="3"
          id="el3"
        >
          <pictures
            v-if="!isEdit[2]"
            @edit="changeEditType(2)"
            @next="handleNext('3')"
          />
          <pictures-form v-else @browsMode="changeEditType(2)" />
        </el-collapse-item>
        <el-collapse-item
          title="* 2.3 以文字分享歷程：上傳 DFC 挑戰學習單"
          name="4"
          id="el4"
        >
          <Pdf
            v-if="!isEdit[3]"
            @edit="changeEditType(3)"
            @next="handleNext('4')"
          ></Pdf>
          <PdfForm v-else @browsMode="changeEditType(3)"></PdfForm>
        </el-collapse-item>
        <el-collapse-item
          title="2.4 故事資料授權暨家長同意書"
          name="5"
          id="el5"
        >
          <Auth
            v-if="!isEdit[4]"
            :is18="is18"
            @edit="changeEditType(4)"
            @next="handleNext('5')"
          ></Auth>
          <AuthForm
            v-else
            :is18="is18"
            @browsMode="changeEditType(4)"
          ></AuthForm>
        </el-collapse-item>
        <el-collapse-item
          v-if="userInfo.role != 'visitor'"
          title="2.5 報名參加 DFC 挑戰分享季"
          name="6"
        >
          <div class="col" gutter="25">
            <p>
              DFC 挑戰發起人——印度河濱學校的瑟吉校長 (Kiran Bir Sethi)
              曾說過：「學習最重要的就是分享所學，但『分享』在教育領域中卻尤其欠缺。」
            </p>
            <p>
              「分享」是 DFC
              四階段中重要的一步。我們期待為孩子創造更多元的舞台，讓行動故事被更多人看見，帶來交流、啟發與影響。
              DFC 臺灣每年會依不同的合作機會與形式，媒合適合的 DFC
              挑戰故事，可能包含協會自媒體、專欄、媒體報導、實體或線上活動，以及國內外故事交流等。DFC
              全球夥伴也會舉辦全球年會，讓各地孩子一起分享故事、彼此交流，DFC
              臺灣也會爭取臺灣組別代表參與的機會。
            </p>
            <p>
              上述分享與交流機會，實際管道、形式與名額將依當年度規劃而有所不同。
            </p>
            <div class="col" align-x="center" gutter="40">
              <div class="col" gutter="5" style="width: 95%">
                <el-popover trigger="hover" title="提示" placement="top">
                  <i class="el-icon-info" style="color: red"
                    >&nbsp;如欲參加分享季，請確認：
                    <ol>
                      <li><b>步驟 2.6「故事影片」</b>已上傳；</li>
                      <li><b>步驟 2.4「同意授權」</b>勾選<b>同意</b></li>
                    </ol>
                  </i>
                  <el-tag class="center" slot="reference">
                    <el-checkbox
                      v-model="editStoryData.is_participate"
                      :disabled="checkboxDisabled"
                      >我們要參與DFC挑戰分享季，讓更多人看到我們解決問題的故事！</el-checkbox
                    >
                  </el-tag>
                </el-popover>
                <br />
                <p style="color: red; margin: 0">
                  *請務必完成填寫步驟 2.4 故事資料授權、2.6上傳 DFC
                  挑戰故事影片喔（皆需要按儲存後，方能勾選此選項）！
                </p>
                <p style="margin: 0">
                  *勾選此選項，僅代表貴團隊有意願被 DFC
                  臺灣團隊媒合，每年可媒合的管道與數量不同，如有合適的機會，我們將主動聯繫您。
                </p>
                <p style="margin: 0">
                  *DFC 臺灣團隊保有隨時修改及終止本活動之權利，若有更動，將依
                  DFC 臺灣官網網站公佈為準。
                </p>
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item title="2.6 上傳 DFC 挑戰故事影片" name="7" id="el7">
          <Video
            v-if="!isEdit[6]"
            @edit="changeEditType(6)"
            @next="handleNext('7')"
          ></Video>
          <VideoForm v-else @browsMode="changeEditType(6)"></VideoForm>
        </el-collapse-item>
        <el-collapse-item title="2.7 勾選符合的 SDGs 項目" name="8" id="el8">
          <Sdgs
            v-if="!isEdit[7]"
            @edit="changeEditType(7)"
            @next="handleNext('8')"
          ></Sdgs>
          <SdgsForm v-else @browsMode="changeEditType(7)"></SdgsForm>
        </el-collapse-item>
        <el-collapse-item title="* 3.1 填寫國際證書資料" name="9" id="el9">
          <Certificate
            v-if="!isEdit[8]"
            @edit="changeEditType(8)"
            :is18="is18"
            @next="handleNext('9')"
          ></Certificate>
          <CertificateForm
            v-else
            :is18="is18"
            @browsMode="changeEditType(8)"
          ></CertificateForm>
        </el-collapse-item>
        <el-collapse-item
          v-if="userInfo.role != 'visitor'"
          title="* 3.2 填寫輔導員問卷"
          name="10"
          @next="handleNext('10')"
          id="el10"
        >
          <Questionnaire :is18="is18"></Questionnaire>
        </el-collapse-item>
        <el-collapse-item title="3.3 學生填寫自評表" name="11">
          <div class="tips" style="margin-bottom: 2rem">
            為了讓參與 DFC 挑戰的學生完整回顧這段精彩的歷程，DFC
            臺灣特別設計了一份課後自評表，共有 64
            道單選題，學生填寫完成後，會立即得到一份專屬的「 DFC
            八大智能探索指南」，幫助他們更了解自己在 DFC
            挑戰過程中展現了哪些多元智能，以及未來可以如何繼續深化這些能力。
            <br />
            這份自評表也是本次 DFC
            挑戰的最後一步，每位學生都需要完成，才能獲得國際證書喔。
          </div>
          <div class="col" align-x="center">
            <a
              class="color-white question-button button-tp bg-pink1"
              :href="surveyCakeUrl"
              target="_blanek"
              >自評表連結</a
            >
          </div>
          <p class="color-danger">
            *請輔導員將自評表連結分享給所有參與 DFC 挑戰之學生，DFC
            臺灣在頒發國際證書前，會核對本組學生皆已完成填寫，才會寄出證書。
          </p>
        </el-collapse-item>
      </el-collapse>
      <div class="submit col">
        <div class="el-collapse-item__header">送出資料</div>
        <div class="el-collapse-item__content col" gutter="25">
          <div class="col layout-align-center" gutter="5">
            <div
              class="button-tp submit-story-button color-white bg-pink1"
              :class="{ disableApply: disableApply }"
              @click="handleApplyStory(editStoryData)"
            >
              送出故事資料
            </div>
            <span class="color-danger">送出後資料將無法再作修改！</span>
          </div>
        </div>
      </div>
    </layout-gray>
    <div class="footer-btn-box layout-row">
      <el-button type="info" class="back-btn" @click="backPost">
        回上一頁</el-button
      >
      <el-button
        class="failed-mesage-btn"
        type="primary"
        :disabled="editStoryData.apply_status != 3 && !isDebug"
        @click="applyFailedDialogVisible = true"
        v-if="editStoryData.apply_status == 3 || isDebug"
      >
        顯示資料不完整提示</el-button
      >
    </div>

    <el-dialog title="資料不完整" :visible.sync="applyFailedDialogVisible">
      <p>
        感謝你與我們分享你改變世界的故事，離上傳完成就差一點點了！<br />以下資料需要再次確認喔！
      </p>
      <div v-html="failMessageTransform"></div>
      <p>你可以在資料確認完整後，再次送出，<br />與我們分享你的故事！</p>
      <p>
        DFC 挑戰客服信箱 challenge@dfctaiwan.org <br />DFC 挑戰客服專線 (02)
        2368-1310 <br />服務時間：週一至週五，上午10:00~18:00
      </p>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="applyFailedDialogVisible = false"
          >確定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import LayoutGray from "@/components/challenge/signUp/LayoutGray.vue";
import { mapActions, mapState } from "vuex";
import config from "@/data/config.json";
import Joi from "joi";
import _ from "lodash";

// ?debug=true 時用來預覽「資料不完整」跳窗的假退件原因
const debugFailedMessage = [
  "【資料不完整】參加挑戰故事之小組成員或輔導員資料填寫不完整，敬請檢查。",
  "【影片＿上傳】未收到您的影片或您的影片不完整，敬請協助上傳。",
].join("\n");

import {
  Team,
  TeamFormUnder18,
  TeamFormUpper18,
  Problem,
  ProblemForm,
  Video,
  VideoForm,
  Auth,
  AuthForm,
  Certificate,
  CertificateForm,
  PicturesForm,
  Pictures,
  Pdf,
  PdfForm,
  Questionnaire,
} from "@/components/challenge/signUp/editStory";

export default {
  components: {
    LayoutGray,
    Team,
    TeamFormUnder18,
    TeamFormUpper18,
    Problem,
    ProblemForm,
    Video,
    VideoForm,
    Auth,
    AuthForm,
    Certificate,
    CertificateForm,
    PicturesForm,
    Pictures,
    Pdf,
    PdfForm,
    Questionnaire,
    Sdgs: () => import("@/components/challenge/signUp/editStory/SDGs"),
    SdgsForm: () => import("@/components/challenge/signUp/editStory/SDGsForm"),
  },
  data() {
    return {
      applyFailedDialogVisible: false,
      isEdit: [false, false, false, false, false, false, false, false, false],
      activeNames: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11"],
      is18: false,
      shareSession: config.shareSession,
      blackList: [0, 1, 2, 3, 4, 9, 10], // 必填項目
    };
  },
  computed: {
    ...mapState("story", ["editStoryData"]),
    ...mapState("user", ["userInfo"]),
    isDebug() {
      return this.$route.query.debug == "true";
    },
    failMessageTransform() {
      var message = this.editStoryData.failed_message;
      if (!message && this.isDebug) message = debugFailedMessage;
      if (message) {
        return message.replace(/[\r\n]/g, "<br/>");
      }
    },
    checkboxDisabled() {
      let authVal = this.handleAuth();
      const { src } =
        (this.editStoryData && this.editStoryData.video) || new Object();
      const { agree_authorize } = this.editStoryData || new Object();

      if (authVal && src && agree_authorize) return false;
      else {
        this.editStoryData.is_participate = false;
        return true;
      }
    },
    disableApply() {
      let storyStatus = this.editStoryData.apply_status;
      let canEditStatus = [1, 3];

      if (this.userInfo.role == "visitor") {
        return true;
      }

      if (
        _.indexOf(canEditStatus, storyStatus) != -1 &&
        this.userInfo.role != "visitor"
      ) {
        return false;
      }

      return true;
    },
    surveyCakeUrl() {
      return process.env.VUE_APP_SURVEYCAKE_URL || "";
    },
  },
  methods: {
    ...mapActions("story", [
      "fetchEditStory",
      "applyStory",
      "getQuestionnaireStatus",
    ]),

    changeEditType(i) {
      this.$set(this.isEdit, i, !this.isEdit[i]);
    },
    async init() {
      this.storyId = this.$route.params.id;
      if (this.$route.query.is18) {
        this.is18 =
          this.$route.query.is18 && JSON.parse(this.$route.query.is18);
      }
      await this.getStoryData();
      this.initIsEdit();
      this.detetctIsFailed();
    },
    initIsEdit() {
      let barList = _.cloneDeep(this.editStoryData.progress.bar_list);
      this.isEdit.map((item, index) => {
        // 因為組員資料佔2個進度所以要+1
        if (!barList[index + 1]) {
          this.isEdit[index] = true;
        }
      });
      this.isEdit = _.cloneDeep(this.isEdit);
    },
    detetctIsFailed() {
      if (this.editStoryData.apply_status == 3 || this.isDebug) {
        this.applyFailedDialogVisible = true;
      }
    },
    async getStoryData() {
      try {
        await this.fetchEditStory(this.storyId);
        await this.getQuestionnaireStatus();
        if (this.$route.query.is18 == undefined) {
          this.$router.replace({
            query: { ...this.$route.query, is18: this.editStoryData.is_18 },
          });
          this.is18 = this.editStoryData.is_18;
        }
      } catch (e) {
        this.$message.error(e);
      }
    },
    handleNext(name) {
      if (_.indexOf(this.activeNames, name) != -1) {
        _.remove(this.activeNames, (activeName) => {
          return activeName == name;
        });
      } else {
        this.activeNames.push(name);
      }
      this.activeNames = _.cloneDeep(this.activeNames);
    },
    backPost() {
      window.history.go(-1);
    },
    checkValidate(progress) {
      /**
       * 0: 填寫小組成員資訊
       * 1: 加入其他輔導員夥伴
       * 2: 感受
       * 3: 照片
       * 4: 學習單
       * 5: 創用CC授權書
       * 6: 影片
       * 7: SDGs
       * 8: 國際證書
       * 9: 輔導員問卷
       * 10: DFC Taiwan 審核
       */
      let list = progress.bar_list;
      // 黑名單裡必須找不到false項目（未完成項目）
      return this.blackList.every((i) => list[i]);
    },
    checkSchoolsSelected() {
      let hasError = false;

      // Check team members
      this.editStoryData.team_members.forEach((member) => {
        if (!member.department_zh) {
          this.$set(member, "showSchoolError", true);
          hasError = true;
        } else {
          this.$set(member, "showSchoolError", false);
        }
      });

      // Check counselors
      this.editStoryData.counselors.forEach((member) => {
        if (!member.department_zh) {
          this.$set(member, "showSchoolError", true);
          hasError = true;
        } else {
          this.$set(member, "showSchoolError", false);
        }
      });

      if (hasError) {
        // Scroll to the certificate section
        this.$scrollTo("#el9", 700, {});
        // Open the certificate section if it's not already open
        if (_.indexOf(this.activeNames, "9") === -1) {
          this.activeNames.push("9");
          this.activeNames = _.cloneDeep(this.activeNames);
        }
        // Switch to edit mode if not already in edit mode
        if (!this.isEdit[8]) {
          this.isEdit[8] = true;
          this.isEdit = _.cloneDeep(this.isEdit);
        }
      }

      return !hasError;
    },

    async handleApplyStory(data) {
      if (!this.disableApply) {
        this.$confirm("送出後資料將無法再作修改！", "提示", {
          confirmButtonText: "確定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            if (!this.disableApply) {
              // First check if all schools are selected
              if (!this.checkSchoolsSelected()) {
                this.$message.error("請為所有成員選擇學校");
                return;
              }

              if (this.checkValidate(data.progress)) {
                await this.applyStory(data);
                this.$message.success("報名成功，我們會儘速審核");
                this.isEdit.map((item, index) => {
                  this.isEdit[index] = false;
                });
                this.isEdit = _.cloneDeep(this.isEdit);
              } else {
                this.scrollToError(data.progress);
                this.$message.error(data.progress.message);
              }
            }
          })
          .catch(() => {});
      }
    },
    async scrollToError({ bar_list }) {
      const index = this.blackList.find((i) => !bar_list[i]);
      this.$scrollTo(`#el${index}`, 700, {});
    },
    validator(data, schema) {
      const { error } = Joi.validate(data, schema, {
        allowUnknown: true,
      });
      if (error) return false;
      return true;
    },
    handleAuth() {
      let data = this.editStoryData;
      let authTeamMambersVal;
      authTeamMambersVal = this.validator(
        data.team_members,
        Joi.array().min(1).required(),
      );

      let authCounselorsVal = this.validator(
        data.counselors,
        Joi.array().min(1).required(),
      );

      if (authTeamMambersVal && authCounselorsVal) {
        return true;
      } else {
        return false;
      }
    },
  },
  async created() {
    await this.init();
    this.$notify({
      title: "警告",
      message: "系統只支援單人存取，請避免多人同時編輯同一欄位。",
      type: "warning",
      duration: 0,
    });
  },
};
</script>

<style lang="scss">
.edit-story {
  max-width: 900px;

  .disableApply {
    background-color: #909399;
    cursor: not-allowed;
  }

  .el-collapse-item__header {
    background-color: #ececec !important;
    padding-left: 10px;
  }
  .el-collapse-item__content {
    background-color: #f6f7f8 !important;
    padding: 20px;
  }
  .el-collapse-item__arrow {
    line-height: 48px !important;
  }

  .submit-story-button {
    width: 380px;
    height: 52px;
  }

  .footer-btn-box {
    margin: 20px 40px;
  }
}
.question-button {
  width: 379px;
  height: 52px;
  text-decoration: none;
}
</style>
